(function() {
    'use strict';
    angular
        .module('bhsApp')
        .factory('Formulaire', Formulaire);

    Formulaire.$inject = ['$resource', 'DateUtils'];

    function Formulaire ($resource, DateUtils) {
        var resourceUrl =  'api/formulaires/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateSaisie = DateUtils.convertDateTimeFromServer(data.dateSaisie);
                        data.dateVerification = DateUtils.convertDateTimeFromServer(data.dateVerification);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
